module.exports = __webpack_public_path__ + "img/gbLogo.849b779f.svg";